import axios from "../../axios"

const header = (token) => {
  return {
    headers: {
        Authorization: "Bearer "+ token
    }
  }
}

export default {
  async getAllErps(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/erps';
    try {
      return await axios.get('',  {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
  async erpProductIntegration(tenantName, token, id, fromAdmin = false) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/erps';
    try {
      return await axios.post('/erp-product-integration', {
        id: id,
        from_admin: fromAdmin
      }, {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
  async suggestIntegrationDatabaseName(tenantName, token, id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/erps';
    try {
      return await axios.get('/suggest-integration-database-name', {
        params: {
          tenantName: tenantName,
          id: id
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
  async createIntegrationsDatabase(tenantName, token, id, name, performedByEmail, performedByName) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/erps';
    try {
      return await axios.post('/create-integration-database', {
        id: id,
        name: name,
        performedByEmail: performedByEmail,
        performedByName: performedByName
      }, {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
  async getIntegrationDatabaseLogs(tenantName, token) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + '/api/erps';
    try {
      return await axios.get('/integration-database-logs', {
        params: {
          tenantName: tenantName
        },
        ...header(token)
      });
    } catch(Exception) {
      console.log(Exception);
      throw Exception
    }
  },
}